/**
 *  Campaigns constant module file
**/

export const MODULE_NAME = 'campaigns'

export const ACTIONS = {
  FETCH_COPY_TASKS: 'FETCH_COPY_TASKS',
  DELETE_COPY_TASKS: 'DELETE_COPY_TASKS'
}

export const GETTERS = {
}

export const MUTATIONS = {
  SET_META: 'SET_META',
  SET_CAMPAIGNS_COMPARE: 'SET_CAMPAIGNS_COMPARE',
  SET_COPY_TASKS: 'SET_COPY_TASKS',
  SET_COPY_TASKS_LOADING: 'SET_COPY_TASKS_LOADING',
  CLEAR_COPY_TASKS: 'CLEAR_COPY_TASKS'
}
